export default __webpack_public_path__ + "static/media/Mockup-Laptop-1.44cb813c.png";